// Selectors for Insights Keywords
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { InsightsKeywordState } from './state';
import { insightsKeywordStateFeatureKey } from './reducer';

const getKeywordsState = createFeatureSelector<InsightsKeywordState>(insightsKeywordStateFeatureKey);

export const selectKeywords = createSelector(getKeywordsState, (state: InsightsKeywordState) => state.keywords);
export const selectLoading = createSelector(getKeywordsState, (state: InsightsKeywordState) => state.loading);
export const selectError = createSelector(getKeywordsState, (state: InsightsKeywordState) => state.error);
